import {API_ROOT_URL} from 'envs/_current/config'
import {createAsyncAction} from 'modules/asyncCache'
import {baseFieldTypes} from './base/baseFieldTypes'
import {askSchema} from './schema'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

const fields = [
    'description',
    'privacy',
    'user_id',
    'content',
    'photos',
    'container_type',
    'container_id',
    'owner_type',
    'owner_id',
]

const fieldTypes = {
    photos: baseFieldTypes.image,
    description: '',
    privacy: '',
    content: baseFieldTypes.string,
    user_id: baseFieldTypes.auto,
    pinned: [0, 1],
    container_type: '',
    container_id: '',
    owner_type: '',
    owner_id: '',
}

export const ask_create_Api = {
    backend: `Route::post('asks/ask/{type}/{id}/create', 'AskController@createAsk');`,
    root: API_ROOT_URL,
    path: '/asks/ask/:prop/:id/create',
    method: 'POST',
    fields,
    fieldTypes,
    schema: askSchema,
    transform: createTransform(askSchema, 'data'),
}
export const create_ask_create_Api_action =
    () =>
        ({prefixStr = 'post_create_Api', query, values, maxAge = -1}) =>
            createAsyncAction({
                prefixStr: prefixStr + '@ask_create_Api',
                query,
                values,
                apiInfo: ask_create_Api,
                maxAge,
            })

export const ask_deleteAsk_Api = {
    backend: `Route::post('asks/ask/{ask_id}/delete', 'AskController@deleteAsk');`,
    root: API_ROOT_URL,
    path: '/asks/ask/:ask_id/delete',
    method: 'POST',
    schema: askSchema,
    transform: createTransform(askSchema, 'data'),
}
export const create_ask_deleteAsk_Api_action =
    () =>
        ({prefixStr = '', query, values, maxAge = -1}) =>
            createAsyncAction({
                prefixStr: prefixStr + '@ask_deleteAsk_Api',
                query,
                values,
                apiInfo: ask_deleteAsk_Api,
                maxAge,
            })

export const ask_updateAsk_Api = {
    backend: `Route::post('asks/ask/{ask_id}/update', 'AskController@updateAsk');`,
    root: API_ROOT_URL,
    path: '/asks/ask/:ask_id/update',
    method: 'POST',
    fields: ['title', 'description'],
    fieldTypes,
    schema: askSchema,
    transform: createTransform(askSchema, 'data'),
}

export const create_ask_updateAsk_Api_action =
    () =>
        ({prefixStr = 'ask_updateAsk_Api', query, values, maxAge = -1}) =>
            createAsyncAction({
                prefixStr: prefixStr + '@ask_updateAsk_Api',
                query,
                values,
                apiInfo: ask_updateAsk_Api,
                maxAge,
            })

export const ask_getById_Api = {
    backend: `Route::get('asks/ask/{ask_id}/get', 'AskController@getById');`,
    root: API_ROOT_URL,
    path: '/asks/ask/:ask_id/get',
    method: 'GET',
    fields,
    fieldTypes,
    schema: askSchema,
    transform: createTransform(askSchema, 'data'),
}
export const create_ask_getById_Api_action =
    () =>
        ({prefixStr = 'ask_getById_Api', query, values, maxAge = -1}) =>
            createAsyncAction({
                prefixStr: prefixStr + '@ask_getById_Api',
                query,
                values,
                apiInfo: ask_getById_Api,
                maxAge,
            })
//
// export const ask_setBestComment_Api = {
//   backend: `Route::post('asks/ask/{ask_id}/comment/{comment_id}/set-best-answer', 'AskController@setBestComment');`,
//   root: API_ROOT_URL,
//   path: '/asks/ask/:ask_id/comment/:comment_id/set-best-answer',
//   method: 'POST',
//   schema: askSchema,
//   transform: createTransform(askSchema, 'data'),
// }
//
// export const ask_unsetBestComment_Api = {
//   backend: `Route::post('asks/ask/{ask_id}/comment/{comment_id}/unset-best-answer', 'AskController@unsetBestComment');`,
//   root: API_ROOT_URL,
//   path: '/asks/ask/:ask_id/comment/:comment_id/unset-best-answer',
//   method: 'POST',
//   schema: askSchema,
//   transform: createTransform(askSchema, 'data'),
// }

export const ask_fetchAskQuestions_Api = {
    backend: `Route::get('asks/ask/search', 'AskController@fetchAskQuestions'); // keyword`,
    root: API_ROOT_URL,
    path: '/asks/ask/search',
    method: 'GET',
    paramsFields: ['keyword'],
    schema: askSchema,
    transform: createListTransform(askSchema),
}


export const ask_fetchSuggestionAskAppChoices_Api = {
    name: 'ask_fetchSuggestionAskAppChoices_Api',
    backend: `Route::get('recommendations/ask/suggested-items', 'PromoteController@getAsks');`,
    root: API_ROOT_URL,
    path: '/recommendations/ask/suggested-items',
    method: 'GET',
    paramsFields: ['category_id'],
    schema: askSchema,
    transform: createListTransform(askSchema),
}


export const ask_fetchItems_Api = {
    name: 'ask_fetchItems_Api',
    backend: `Route::get('asks/fetch-items', 'AskController@fetchItems');`,
    root: API_ROOT_URL,
    path: '/asks/fetch-items',
    method: 'GET',
    // category_ids: comma-separated Category idnames (đệ quy) — dùng cho chips category /discussions
    // status: 'unanswered' — ask chưa có ask_comments nào (dùng cho sub-tab "Chờ trả lời" /discussions)
    // language: content language ('vi'/'en') — bảng asks CHƯA có cột language, tham số này hiện
    // được BE bỏ qua (không lỗi, chỉ chưa lọc được) — chuẩn bị sẵn luồng UI cho tới khi BE hỗ trợ.
    paramsFields: ['sort_by', 'keyword', 'category_ids', 'status', 'language'],
    schema: askSchema,
    transform: createListTransform(askSchema),
}

// KPI đơn giản cho hero header /discussions: tổng câu hỏi / đã giải đáp / số người tham gia.
// Không có "chuyên gia"/"trả lời đã duyệt" — chưa có cờ tương ứng ở backend, cố tình bỏ (xem plan).
export const ask_getStats_Api = {
    name: 'ask_getStats_Api',
    backend: `Route::get('asks/ask/stats', 'AskController@getAskStats');`,
    root: API_ROOT_URL,
    path: '/asks/ask/stats',
    method: 'GET',
}